import React, { Component } from 'react'
import { browserHistory, Link } from 'react-router'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ValidationError from './validation-error'
import * as actions from '../actions'
import { updateUserAsAdmin } from '../actions/as-admin'
import Loader from './loader'

const renderCellnumberField = ({ input, label, type, meta: { touched, error, warning } }) => {

  return (
    <div className="form-group">
      <label>{label}</label>
      <input
        className='form-control'
        {...input}
        placeholder={label}
        type={type}
        autoFocus={true}
      />
      {touched && ((error && <ValidationError error={error} type={"error"}/>) || (warning && <ValidationError error={warning} type={"warning"}/>))}
    </div>
  )

}

const renderDescriptionField = ({ input, label, type, meta: { touched, error, warning } }) => {

  return (
    <div className='form-group'>
      <label>{label}</label>
      <textarea className='form-control' {...input} placeholder={label} />
      {touched && ((error && <ValidationError error={error} type={"error"}/>) || (warning && <ValidationError error={warning} type={"warning"}/>))}
    </div>
  )

}

let EditForm = props => {
  const { handleSubmit, load, pristine, invalid, reset, submitting, cancel } = props
  return (
    <form onSubmit={handleSubmit}>
      <div className='form-group'>
        <label>ID Number</label>
        <Field component='input' type='text' name='sub' className='form-control' readOnly/>
      </div>
      <Field
        component={renderCellnumberField}
        type='tel'
        label='Cell number'
        name='cellnumber'
      />
      <div className='form-group'>
        <div className='alert alert-warning'>
          The pairing of ID number and cell number controls access to a user account. Therefore, changing
          this pairing must be done <em>after verifying the authenticity of the change request</em>.
          <br/>
          Describe below the verification you performed.
        </div>
      </div>
      <Field
        component={renderDescriptionField}
        rows={5}
        name='verificationDescription'
        label='Your verification'
      />
      <button
        type="submit"
        className="btn btn-success btn-block" disabled={pristine || invalid || submitting}>
        { submitting ? 'Updating...' : 'Update user details' }
      </button>
      <button
        onClick={cancel}
        className="btn btn-default btn-block" disabled={submitting}>
        Cancel
      </button>
    </form>
  )
}

const isValidSouthAfricanCellnumber = value => {
  const digits = value.replace(/\D/g, '')
  if (digits.length == 10 && digits[0] === '0' && digits[1] !== '0') {
    return true
  }
  return false
}

const isInternationalCellnumber = value => {
  value = value.replace(/\s/g, '') // remove all whitespace
  if (!value.startsWith('+')) {
    return false
  }
  value = value.replace(/\D/g, '') // remove all non-digits
  return value.length > 6 // we expect at least so many digits
}

const validate = values => {
  const errors = {}
  if (!values.cellnumber) {
    errors.cellnumber = 'A valid cell number must be specified.'
  } else {
    if (!isValidSouthAfricanCellnumber(values.cellnumber)
      && !isInternationalCellnumber(values.cellnumber)
    ) {
      errors.cellnumber = 'Must either be a South African cell number, or an internaional cell number starting with "+"'
    }
  }
  if (!values.verificationDescription || values.verificationDescription.trim().split(' ').length < 5) {
    errors.verificationDescription = 'You must specify the verification steps taken (at least 5 words)!'
  }
  return errors
}

EditForm = reduxForm({
  form: 'editUserAsAdmin',
  validate,
  onSubmit: (values, dispatch) => {
    console.log('onSubmit, values', values)
    return dispatch(updateUserAsAdmin(values))
  }
})(EditForm)

const normalizeCellnumberInitially = c => {
  if (c.startsWith('27')) {
    return '0' + c.substr(2)
  } else {
    return '+' + c
  }
}

EditForm = connect(state => {
  const user = state.userAsAdmin.user
  return {
    initialValues: {
      cellnumber: normalizeCellnumberInitially(user.cellnumber),
      sub: user.sub
    }
  }
}, dispatch => ({
  cancel: () => browserHistory.push('/')
}))(EditForm)

class ViewAsAdmin extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const { idno } = this.props
    const { loadUser } = this.props
    loadUser(idno)
  }

  render() {
    const { user, loading } = this.props
    if (loading) {
      return <Loader />
    }
    if (!user) {
      return (<div className='content'>
        <div className='container'>
          No such user. <Link to="/">Go back</Link>
        </div>
      </div>)
    }
    return (
      <div>
        <div className='info'>
          <div className='container'>
            <h2>View/Update User { user && user.sub } </h2>
          </div>
        </div>
        <div className='content'>
          <div className='container'>
            <EditForm />
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state.userAsAdmin
  const { loading } = state
  return {
    user: user,
    loading: loading
  }
}

function mapDispatchToProps(dispatch) {
  return ({
    loadUser: bindActionCreators(actions.viewAsAdmin, dispatch)
  })
}

const ConnectedViewAsAdmin = connect(mapStateToProps, mapDispatchToProps)(ViewAsAdmin)
export default ConnectedViewAsAdmin



// WEBPACK FOOTER //
// ./src/app/components/view-as-admin.js